<section class="about mt-24">
  <div class="grid md:grid-cols-2 gap-x-10">
    <div class="flex">
      <img src="assets/home.jpg" alt="" class="object-cover" />
    </div>
    <div class="px-8 md:px-0">
      <h2 class="text-2xl mt-6">Oferta</h2>
      <p class="mt-6">
        W naszej ofercie znajduje się ponad 200 rodzajów pojemników, które
        świetnie sprawdzają się podczas ekspozycji:
      </p>
      <ul class="columns-2 list-disc mt-6 pl-10 gap-8">
        <li>mięsa</li>
        <li>wędlin</li>
        <li>serów</li>
        <li>sałatek</li>
        <li>oliwek</li>
        <li>wyrobów delikatesowy</li>
        <li>chwyrobów cukierniczych</li>
        <li>wyrobów piekarniczych</li>
        <li>ryb (również ryb na lodzie)</li>
        <li>i innych wyrobów spożywczych</li>
      </ul>
      <p class="mt-4 mb-8">
        Zapoznaj się z naszą <a href="/produkty" class="underline text-blue-700">ofertą</a> i <a href="/kontakt" class="underline text-blue-700">skontaktuj się</a> z nami.
      </p>
    </div>
  </div>
</section>
